/*
---
description: FED Process
authors:
- David Chan CK
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Page = new Class({
	Implements: [Events],

	initialize: function(){
		this.widgets = [];
		this.pre();
		this.build();
		this.widgetize();
		this.post();
		Core.init_recaptcha();
	},

	pre: function(){
		Core.track_g_tag();
		new UserTools();
		Core.add_outsider_grabber();

		this.previous_page_id = Core.get_previous_page_id();
	},

	build: function() {
		var bodyId = $(document.body).get('id');

		//do not change this order: ++++++++++++++++++++++++++++
		Core.add_dropdownmenu_support();
		if (bodyId === 'lst') {
			Core.add_stalker_support({toggle_nav_element: '.building_section'});	
		} else if (bodyId === 'bop') {
			Core.add_stalker_support({double_nav: true});
		} else if (bodyId === 'lsr') {
			Core.add_stalker_support({toggle_nav: false});
		} else {
			Core.add_stalker_support();
		}
		//++++++++++++++++++++++++++++++++++++++++++++++++++++++

		Core.add_anchornator_support();
		Core.add_select_support();
		Core.add_scroll_support();
		Core.add_bars_support();
		Core.add_video_popups_support();
		Core.add_polyfill_find();
		Core.add_polyfill_closest();
	},

	post: function() {
		var bodyId = $(document.body).get('id');
		Core.to_mobile_link();

		// Email Popup links
		var _link_emails = document.getElements('.w_blimp_email');
		if (_link_emails && _link_emails.length > 0){
			_link_emails.each(function(_el){
				new Blimp.Form(_el, {draggable: true});
			});
		}

		Core.add_contact_support();
		Core.add_mailing_list_support();
		Core.add_subscribe_support();
		Core.add_blimp_forms();
		Core.add_article_support();
		Core.add_signin_support();
		Core.add_side_search_miniquest();
		if (bodyId !== 'bov' && bodyId !== 'npr' && bodyId !== 'bdw' && bodyId !== 'lst' && bodyId !== 'lsr' && bodyId !== 'mia') {
			Core.stick_last_ads();
		}

		if (bodyId === 'bdw') {
			Core.stick_building_review_last_ads('key-details');
		}

		if (bodyId === 'lst' ) {
			Core.stick_listing_contact_form_and_ads();
		}

		if (bodyId === 'mia') {
			Core.stick_market_insight_callout_ads();
		}

		Core.set_content_position();

		var _multisortables = document.getElements('.w_multisortable');

		if(_multisortables && _multisortables.length > 0){
			_multisortables.each(function(_el){
				new Multisortable(_el, {
					divtable_zebra_order: 'odd'
				});
			});
		}

		var _divtables = document.getElements('.ava_apts, .disp_blds');
		if(_divtables  && _divtables.length > 0){
			new TableOptions();
			Core.add_img_lazyloader(); //has to be after Multisortable
		}

		Core.clear_sales_data_cookies();

		Core.add_footer_support();
		Core.add_broker_toggle_support();
		Core.update_date_range_title();

		var _promo_tab = document.getElement('.w_promo_tab');
		// check if PromoTab is defined
		if (_promo_tab && typeof (PromoTab) === 'function') {
			new PromoTab(_promo_tab);
		} 
		

	},

	widgetize: function() {
		var bdy = document.id(document.body),
			widgets = bdy.getAttribute('data-widgets');

		if (widgets && widgets.trim() != '') {
			widgets = widgets.explode('::');
			var w;

			widgets.each(function(widget) {
				widget = widget.trim();
				var params = widget.explode('|');

				if (params.length > 1) {
					widget = params[0].trim();
					params = params[1].trim();
				} else {
					params = null;
				}

				if (window[widget] == undefined) return;

				eval('w = typeOf('+widget+')');

				if (w == 'class') {
					eval('w = new '+widget+'('+params+')');
					this.widgets.push(w);
				}
			}.bind(this));
		}
	}
});
